var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editable-cell"},_vm._l((_vm.text),function(item){return _c('a-tag',{key:item},[_vm._v(_vm._s(item)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }